module.exports = __webpack_public_path__ + "static/media/audio-pdf-thumbnail.effe3a63.png";